// extracted by mini-css-extract-plugin
export var brand = "_9z-9";
export var compact = "_9z-6";
export var extraSmall = "_9z-7";
export var icon = "_9z-0";
export var large = "_9z-4";
export var light = "_9z-1";
export var medium = "_9z-5";
export var outline = "_9z-b";
export var primaryDark = "_9z-a";
export var primaryLight = "_9z-8";
export var primaryModern = "_9z-c";
export var success = "_9z-2";
export var successSolid = "_9z-3";